import React from 'react'
import { Routes, Route } from 'react-router-dom';
import Homeone from '../components/Home/Homeone/Main';
import Hometwo from '../components/Home/Hometwo/Main';
import Homethree from '../components/Home/Homethree/Main';
import Aboutus from '../components/Pages/Aboutus/Main';
import Faq from '../components/Pages/Faq/Main';
import Careers from '../components/Pages/Careers/Main';
import Applyaloan from '../components/Pages/Applyaloan/Main';
import Team from '../components/Pages/Team/Main';
import FoundersMessage from '../components/Pages/FoundersMessage/Main';
import TeamDetails from '../components/Pages/TeamDetails/Main';
import Services1 from '../components/Services/Services1/Main';
import Services2 from '../components/Services/Services2/Main';
import Servicesdetails from '../components/Services/Servicesdetails/Main';
import Portfolio from '../components/Portfolio/Portfolio/Main';
import PortfolioGrid from '../components/Portfolio/PortfolioGrid/Main';
import PortfolioDetails from '../components/Portfolio/PortfolioDetails/Main';
import Contactus from '../components/Contactus/Main';
import Blogstandard from '../components/Blog/Blogstandard/Main';
import Bloggrid from '../components/Blog/Bloggrid/Main';
import Bloggrid2 from '../components/Blog/Bloggrid2/Main';
import Blogdetails from '../components/Blog/Blogdetails/Main';
import Services from '../components/Services/Services/Main'
import Services3 from '../components/Services/Servicesdetails/Services3'
import Services4 from '../components/Services/Servicesdetails/Services4'
import Services5 from '../components/Services/Servicesdetails/Services5'
import Services6 from '../components/Services/Servicesdetails/Services6'
import Services7 from '../components/Services/Servicesdetails/Services7'
import Services8 from '../components/Services/Servicesdetails/Services8'
import Services9 from '../components/Services/Servicesdetails/Services9'
import Services10 from '../components/Services/Servicesdetails/Services10'
import Services11 from '../components/Services/Servicesdetails/Services11'
import RealEstateManagement from '../components/Services/Servicesdetails/Services12';
import Resources from '../components/Portfolio/Resources/Main'
import Blogdetails2 from '../components/Blog/Blogdetails2/Main'
import Blogdetails3 from '../components/Blog/Blogdetails3/Main'
import Privacy from '../components/Pages/Privacy/Main';
import Terms from '../components/Pages/Terms/Main';

const index = () => {
   
    return (
        <Routes>
            <Route path='/' element={<Homeone />} />
            <Route path='/Hometwo' element={<Hometwo />} />
            <Route path='/Homethree' element={<Homethree />} />
            <Route path='/core-values' element={<Aboutus />} />
            <Route path='/founders-message' element={<FoundersMessage />} />
            <Route path='/india-team' element={<Faq />} />
            <Route path='/us-team' element={<Careers />} />
            <Route path='/canada-team' element={<Applyaloan />} />
            <Route path='/our-team' element={<Team />} />
            <Route path='/TeamDetails' element={<TeamDetails />} />
            <Route path='/execution-of-wills' element={<Services1 />} />
            <Route path='/about-us' element={<Services2 />} />
            {/* <Route path='/real-estate-management' element={<Servicesdetails />} /> */}
            <Route path='/why-choose-us' element={<Portfolio />} />
            <Route path='/the-advisors-way' element={<PortfolioGrid />} />
            <Route path='/testimonials' element={<PortfolioDetails />} />
            <Route path='/blog' element={<Blogstandard />} />
            <Route path='/brand-vision' element={<Bloggrid />} />
            <Route path='/blog-grid-2' element={<Bloggrid2 />} />
            <Route path='/blog-details' element={<Blogdetails />} />
            <Route path='/contact-us' element={<Contactus />} />
            <Route path='/Services' element={<Services/>} />
            <Route path='/documentation' element={<Services3/>} />
            <Route path='/legal' element={<Services4/>} />
            <Route path='/tours-travel' element={<Services5/>} />
            <Route path='/taxation' element={<Services6/>} />
            {/* <Route path='/medical-services' element={<Services7/>} /> */}
            <Route path='/finance-and-accountancy' element={<Services8/>} />
            {/* <Route path='/immigration' element={<Services9/>} /> */}
            <Route path='/events-and-entertainment' element={<Services10/>} />
            <Route path='/security' element={<Services11/>} />
            <Route path="/real-estate-management" element={<RealEstateManagement />} />
            <Route path='/Resources' element={<Resources/>} />
            <Route path='/Blogdetails2' element={<Blogdetails2/>} />
            <Route path='/Blogdetails3' element={<Blogdetails3/>} />
            <Route path='/privacy-policy' element={<Privacy />} />
            <Route path='/terms-and-conditions' element={<Terms />} />
        </Routes>
    )
}
export default index;